export default __webpack_public_path__ + "static/faq1-d92bd7024a364de17f1c8559a9baf852.png";